import { post } from "../api";
import { type ProductSet } from "./models/ProductSet";

async function createProductSet(body: FormData): Promise<ProductSet> {
    return await post({ url: `/admin/product_sets`, body: body });
}

async function updateProductSet(id: ProductSet[`id`], body: FormData): Promise<ProductSet> {
    return await post({ url: `/admin/product_sets/${id}`, body: body });
}

export async function saveProductSet(productSet: ProductSet | null, body: FormData): Promise<ProductSet> {
    return productSet ? updateProductSet(productSet.id, body) : createProductSet(body);
}
